import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * cn — merge conditional class names and dedupe conflicting Tailwind
 * utilities (last-wins). Standard shadcn/ui helper, used by every
 * primitive in src/components/ui and src/components/primitives.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
